import { IUrlMetadata } from 'app/extensibility/metadatas/validator/url-metadata';
import { IValidatorFactoryService } from './validator-factory.service';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';


export class UrlValidatorFactoryService implements IValidatorFactoryService<IUrlMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'url';

    public createValidatorByMetadata(metadata: IUrlMetadata): IValidatorFn {
        return this.createValidator(metadata.errorMessage);
    }

    public createValidator(errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.InvalidUrlLabel;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            // eslint-disable-next-line max-len
            return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(value) ? null : errorMessage;
        };
    }

    public createKeyVaultUrlWithSecretValidator(errMsg: string): IValidatorFn {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            return /(https:\/\/[A-Za-z0-9-_]*\.vault[A-Za-z0-9-_.]*\/secrets\/\w+)/.test(value) ? null : errMsg;
        };
    }
}
